import { ElMessage, ElMessageBox, ElLoading,ElNotification } from 'element-plus';

import CryptoJS from './crypto-js.min';
import Decimal from 'decimal.js';


export const loadings = {
	value: null,
	show: function () {
		this.value = ElLoading.service({
			lock: true,
			text: '处理中，请稍后',
			background: 'rgba(0, 0, 0, 0.7)'
		});
	},
	hide: function () {
		if (this.value) {
			this.value.close();
		}
	}
}

export const message = {
	error: function (msg = '失败') {
		ElNotification.error(msg);
	},
	success: function (msg = '成功') {
		ElNotification.success(msg);
	},
	warning: function (msg = '警告') {
		ElNotification.warning(msg);
	},
	confirm: function (msg = '确定吗？') {
		return new Promise((resolve,reject)=>{
			ElMessageBox.confirm(msg, '系统提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(res => {
				resolve(true);
			}).catch(err => {
				resolve(false);
			})
		})
	},
	alert: function (msg = '警告') {
		ElMessageBox.alert(msg, '系统提示', {
			confirmButtonText: '知道！',
			type: 'error'
		}).then(r => r);
	}
}

//数据处理
export const strings = {
	replaceNumber: function (val, length = 2) {
		let str = val.replace(/[^0-9.]/g, '');
		if (/\./.test(str)) {
			let array = str.split('.');
			str = array[0];
			if (array[1].length > length) {
				str += '.' + array[1].substr(0, length);
			} else {
				str += '.' + array[1];
			}
		}
		return str;
	},
	replaceInteger: function (val) {
		return val.replace(/[^0-9]/g, '');
	},
	emptyToNumber: function (val) {
		return val === '' ? '0' : val;
	},
	trim: function (val) {
		return val.trim();
	},
	smartFormatNumber: function (val) {
		// 转换为浮点数确保统一处理
		const num = parseFloat(val);

		// 处理无效输入
		if (isNaN(num)) return '0';

		// 处理整数情况
		if (Number.isInteger(num)) {
			return num.toString();
		}

		// 转换为字符串并去除尾部多余的0
		let formatted = num.toString();

		// 处理科学计数法（如1e-7）
		if (formatted.includes('e')) {
			formatted = num.toFixed(10);
		}

		// 正则去除尾部多余的0和小数点
		return formatted.replace(/(\.[0-9]*[1-9])0+$|\.0+$/, '$1');
	},
	/**
	* 高精度计算乘积（支持字符串类型的两位小数数值）
	* @param {string[]} values - 数值数组（每个元素为字符串形式的两位小数）
	* @returns {string} 乘积结果（保留两位小数）
	*/
	preciseProduct: function (values){
		// 1. 参数校验
		if (!Array.isArray(values)) {
			throw new TypeError('输入必须是数组');
		}

		// 2. 空数组返回 "1.00"
		if (values.length === 0) return "0";

		// 3. 格式校验与提前短路优化
		const decimalList = [];
		for (const val of values) {
			// 3.1 校验格式：整数或两位小数
			if (!/^-?\d+(\.\d{1,2})?$/.test(parseFloat(val))) {
				throw new Error(`无效数值格式: "${val}"，应为整数或两位小数`);
			}

			// 3.2 遇0直接短路返回（优化性能）
			if (val === "0" || val === "0") return "0";

			// 3.3 转换为Decimal对象
			decimalList.push(new Decimal(val));
		}

		// 4. 累乘计算（保留完整精度）
		const product = decimalList.reduce(
			(acc, curr) => acc.times(curr),
			new Decimal(1)
		);

		// 5. 格式化为两位小数（银行家舍入法）
		return this.smartFormatNumber(product.toFixed(2, Decimal.ROUND_HALF_EVEN));
	}
}

//时间获取器
export const times = {
	strtotime: function (date) {
		return Date.parse(date);
	},
	nowDate: function () {
		let now = new Date();
		let year = now.getFullYear();
		let month = (now.getMonth() + 1).toString().padStart(2, '0');
		let day = now.getDate().toString().padStart(2, '0');
		return `${year}-${month}-${day}`;
	},
	nowTime: function () {
		return Date.now();
	}
}

//数据校验
export const validator = {
	isMobile: function (val) {
		if (/^1(3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9])\d{8}$/.test(val)) {
			return true;
		} else {
			return false;
		}
	},
	isEmail: function (val) {
		if (/^([a-zA-Z0-9]+[_|_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(val)) {
			return true;
		} else {
			return false;
		}
	},
	isEmpty: function (val) {
		if (val.length < 1) {
			return true;
		} else {
			return false;
		}
	}
}

//数据层级转换
export const listToLevel = ({ list = [], keys = '', pid = '0' ,pkey = 'parent_id'}) => {
	if (list.length === 0) {
		return [];
	}
	let res = [];
	list.forEach(item => {
		if (item[pkey] == pid) {
			item['children'] = listToLevel({ list, keys, pid: item[keys] ,pkey:pkey});
			res.push(item);
		}
	});
	return res;
};


export const err_alert = msg => {
	ElMessageBox.alert(msg, '系统提示', {
		confirmButtonText: '知道！',
		type: 'warning'
	})
		.then(r => r)
		.catch(e => e);
};

export const err_repeat = () => {
	ElMessageBox.alert('请求正在处理，请勿重复点击', '系统提示', {
		confirmButtonText: '知道！',
		type: 'warning'
	})
		.then(r => r)
		.catch(e => e);
};

//数据加密
export const encrypt = data => {
	return CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse('daBmT2PBEJVrZ8iR'), {
		mode: CryptoJS.mode.CBC,
		iv: CryptoJS.enc.Utf8.parse('bGHmtkhefz7sI4k8'),
		padding: CryptoJS.pad.Pkcs7
	}).toString();
};
//数据解密
export const decrypt = data => {
	return CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse('daBmT2PBEJVrZ8iR'), {
		mode: CryptoJS.mode.CBC,
		iv: CryptoJS.enc.Utf8.parse('bGHmtkhefz7sI4k8'),
		padding: CryptoJS.pad.Pkcs7
	}).toString(CryptoJS.enc.Utf8);
};


/**
* 高精度加法函数，支持字符串/数值类型输入，动态保留最大小数位
* @param {string|number} a - 第一个操作数
* @param {string|number} b - 第二个操作数
* @returns {string} 保留最大小数位精度的加法结果
*/
export const numberSum = (a, b) => {
	// 转换为字符串并清理空白字符
	const strA = String(a).trim();
	const strB = String(b).trim();

	// 处理科学计数法（简单转换，实际项目建议用库处理）
	const convertScientific = (str) => {
		if (str.includes('e')) {
			return Number(str).toString();
		}
		return str;
	};

	const numA = convertScientific(strA);
	const numB = convertScientific(strB);

	// 计算最大小数位数
	const getDecimalPlaces = (numStr) => {
		if (!numStr.includes('.')) return 0;
		return numStr.split('.')[1].length;
	};

	const placesA = getDecimalPlaces(numA);
	const placesB = getDecimalPlaces(numB);
	const maxPlaces = Math.max(placesA, placesB);

	// 转换为整数计算
	const multiplier = Math.pow(10, maxPlaces);
	const intA = Math.round(parseFloat(numA) * multiplier);
	const intB = Math.round(parseFloat(numB) * multiplier);
	const intResult = intA + intB;

	// 转换回浮点数并格式化
	const result = intResult / multiplier;

	// 处理整数情况
	if (maxPlaces === 0) {
		return result.toString();
	}

	// 格式化为固定小数位（补零）
	return result.toFixed(maxPlaces);
}

//价格表专属数据处理；
export const addPriceRangeKeys = data => {
	return data.map(item => {
		// 创建原对象的浅拷贝，避免直接修改原数据
		const newItem = { ...item };

		// 遍历priceDetail数组，动态添加新属性
		item.priceDetail.forEach(detail => {
			// 格式化数字为两位小数
			const start = parseFloat(detail.start_number).toFixed(2);
			const end = parseFloat(detail.end_number).toFixed(2);

			// 构建键名（如"0.00-1000.00"）
			const key = `${start}-${end}`;

			// 添加新属性（使用方括号语法处理特殊字符键名）[1,3,4](@ref)
			newItem[key] = String(detail.price); // 统一转换为字符串
		});

		return newItem;
	});
}



